import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { InsCallCenter, CallCenter } from '../models/InsCallCenter';
import { Observable } from 'rxjs';

interface ResponseMSGraph
{
  odatatype: string;
  value: GroupsMSGraph[];
}

interface GroupsMSGraph
{
  odatatype: string;
  id: string;
  mail: string;
}

@Injectable()
export class BdService
{
  //El fragmento para las llamadas a BD
  constructor(private http: HttpClient){}


  //* Llamada para pasar los datos para guardar la llamada
  public setLlamadaEntrante(token:string,callIns:InsCallCenter):Promise<any>
  {
    let url:string = environment.callCenterWSBase + "/CallCenter/GuardarLlamada";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,callIns,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      });
    });
  }

  insertCallCenter(token:string, callCenter:CallCenter[]): Observable<Object>
  {
    let url:string = environment.callCenterWSBase + "/CallCenter";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return this.http.put(url, callCenter, httpOptions);
  }

  public siguienteCodigoSiniestro(token:string):Observable<Object>
  {
    let url:string = environment.callCenterWSBase + "/CallCenter/BuscaRalSin";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return this.http.post(url,"",httpOptions);
  }

  public updateCallcenter(token:string, array: any){
    let url:string = environment.callCenterWSBase  +"/CallCenter/update";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }


    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,array,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public updateAgenda(token:string, array: any){
    let url:string = environment.callCenterWSBase  +"/Agenda";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.put(url,array,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
